import {
  Directive, Input, HostListener
} from '@angular/core';
import { MdlMenuComponent } from './mdl-menu.component';
import { MdlButtonComponent } from '../button/mdl-button.component';


export class MdlToggleMenuDirective {

   public menu: MdlMenuComponent;

  constructor(private button: MdlButtonComponent){}

  
  public onClick($event){
    this.menu.toggle($event, this.button);
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[mdl-button][mdl-toggle-menu]'
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: MdlButtonComponent, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'menu': [{ type: Input, args: ['mdl-toggle-menu', ] },],
'onClick': [{ type: HostListener, args: ['click', ['$event'], ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
